"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YAMLWarning = exports.YAMLSyntaxError = exports.YAMLSemanticError = exports.YAMLReferenceError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _Node = _interopRequireDefault(require("./cst/Node"));

var YAMLReferenceError =
/*#__PURE__*/
function (_ReferenceError) {
  (0, _inherits2.default)(YAMLReferenceError, _ReferenceError);

  function YAMLReferenceError(source, message) {
    var _this;

    (0, _classCallCheck2.default)(this, YAMLReferenceError);

    if (!message || !(source instanceof _Node.default)) {
      throw new Error('Invalid arguments for new YAMLReferenceError');
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(YAMLReferenceError).call(this));
    _this.name = 'YAMLReferenceError';
    _this.message = message;
    _this.source = source;
    return _this;
  }

  return YAMLReferenceError;
}((0, _wrapNativeSuper2.default)(ReferenceError));

exports.YAMLReferenceError = YAMLReferenceError;

var YAMLSemanticError =
/*#__PURE__*/
function (_SyntaxError) {
  (0, _inherits2.default)(YAMLSemanticError, _SyntaxError);

  function YAMLSemanticError(source, message) {
    var _this2;

    (0, _classCallCheck2.default)(this, YAMLSemanticError);

    if (!message || !(source instanceof _Node.default)) {
      throw new Error('Invalid arguments for new YAMLSemanticError');
    }

    _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(YAMLSemanticError).call(this));
    _this2.name = 'YAMLSemanticError';
    _this2.message = message;
    _this2.source = source;
    return _this2;
  }

  return YAMLSemanticError;
}((0, _wrapNativeSuper2.default)(SyntaxError));

exports.YAMLSemanticError = YAMLSemanticError;

var YAMLSyntaxError =
/*#__PURE__*/
function (_SyntaxError2) {
  (0, _inherits2.default)(YAMLSyntaxError, _SyntaxError2);

  function YAMLSyntaxError(source, message) {
    var _this3;

    (0, _classCallCheck2.default)(this, YAMLSyntaxError);

    if (!message || !(source instanceof _Node.default)) {
      throw new Error('Invalid arguments for new YAMLSyntaxError');
    }

    _this3 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(YAMLSyntaxError).call(this));
    _this3.name = 'YAMLSyntaxError';
    _this3.message = message;
    _this3.source = source;
    return _this3;
  }

  return YAMLSyntaxError;
}((0, _wrapNativeSuper2.default)(SyntaxError));

exports.YAMLSyntaxError = YAMLSyntaxError;

var YAMLWarning =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(YAMLWarning, _Error);

  function YAMLWarning(source, message) {
    var _this4;

    (0, _classCallCheck2.default)(this, YAMLWarning);

    if (!message || !(source instanceof _Node.default)) {
      throw new Error('Invalid arguments for new YAMLWarning');
    }

    _this4 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(YAMLWarning).call(this));
    _this4.name = 'YAMLWarning';
    _this4.message = message;
    _this4.source = source;
    return _this4;
  }

  return YAMLWarning;
}((0, _wrapNativeSuper2.default)(Error));

exports.YAMLWarning = YAMLWarning;